module.exports = __webpack_public_path__ + "static/media/uob_bank.d2b60e84.svg";